import React from 'react';
import PropTypes from "prop-types";
import { Modal, Button } from 'rhombus-react';

import { noop } from 'utils/common';
import ConflictsTable from "./ConflictsTable";

import "./SkipMultipleModal.css";

export default function SkipMultipleModal(props) {
	const {
		conflicts,

		onConfirmSkip,
		onBack,
	} = props;

	function renderContent(){
		return (
			<div className="table-container">
				<p className="error-msg">The following creatives already exist in the creative library and will be skipped.</p>
				<div className="conflicts-table">
					<ConflictsTable conflicts={conflicts} />
				</div>
			</div>
		);
	}

	function renderFooter(){
		return (
			<>
				<Button onClick={onBack} theme="default">Back</Button>
				<Button onClick={onConfirmSkip}>Confirm Skipping</Button>
			</>
		);
	}

	let modalProps = {
		type: "modal",
		title: "Confirm Skipping Creative Upload",
		setAppTitle: false,
		allowFullScreen: false,
		className: "creative-upload-error-modal skip-multiple",
		xClose: false,
		bladeProps: {
			verticallyCenter: true,
			initialFocus: "p", /*
				If we don't set initialFocus to something, it will auto focus one of the preview
				links, which the user might open by accident by hitting enter.

				After the user attempts to upload, this modal may pop up while they're in the middle
				of doing something else, so we set a value here that won't actually focus anything.
			*/
		},
		renderContent,
		renderFooter,
	};

	return <Modal {...modalProps} />;
}

SkipMultipleModal.displayName = "SkipMultipleModal";

SkipMultipleModal.propTypes = {
	conflicts: PropTypes.arrayOf(PropTypes.shape({
		filename: PropTypes.string,
		id: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.number
		]),
		approval: PropTypes.string,
		adType: PropTypes.string,
	})),

	onConfirmSkip: PropTypes.func,
	onBack: PropTypes.func,
};

SkipMultipleModal.defaultProps = {
	conflicts: [],

	onConfirmSkip: noop,
	onBack: noop,
};
